import React, { useState } from "react";
import PageWrapper from "../../lib/page-wrapper";
import { AlbumGrid } from "../../lib/album-art";
import "./advertiser_browse_search.scss";

import grid from "../../../icons/grid.svg";
import gridFilled from "../../../icons/grid-filled.svg";
import list from "../../../icons/list.svg";
import listFilled from "../../../icons/list-filled.svg";
import { CSSTransition } from "react-transition-group";
import AdvertiserSearch from "../../lib/show_search/advertiser_search";
import { hummanizeNumber } from "../../../lib/numbers";

const AdvertiserBrowseSearch = props => {
  const [showGrid, updateShowGrid] = useState(true);

  const renderResults = shows => {
    return (
      <AlbumGrid
        noGrid
        customSizes={{ md: 3, sm: 3, xs: 6 }}
        shows={shows.map(show => ({
          ...show,
          toURL: `/browse/${show.uuid}`,
          subtitle: (
            <>
              <div>{show.category}</div>
              <div>{hummanizeNumber(show.estimatedWeeklyDownloads)} Weekly Downloads</div>
            </>
          ),
        }))}
      />
    );
  };

  return (
    <CSSTransition in={props.show} classNames={"browse-search"} timeout={500} unmountOnExit>
      <div className={"advertiser-browse-search"}>
        <PageWrapper
          title={"Search Podcasts"}
          afterTitleElement={() => (
            <div className={"margin-left--large"}>
              <span className="bold">View: &nbsp;</span>
              <img
                className={"pointer margin-right--small"}
                onClick={() => updateShowGrid(false)}
                src={showGrid ? list : listFilled}
                alt="grid-button"
              />
              <img
                className={"pointer"}
                onClick={() => updateShowGrid(true)}
                src={showGrid ? gridFilled : grid}
                alt="list-button"
              />
            </div>
          )}>
          <AdvertiserSearch
            renderer={showGrid ? renderResults : undefined}
            tableProps={{
              onRow: record => ({
                onClick: () => {
                  window.open(`/browse/${record.uuid}`, "_blank");
                },
              }),
              rowClassName: "pointer",
            }}
          />
        </PageWrapper>
      </div>
    </CSSTransition>
  );
};

export default AdvertiserBrowseSearch;
